<template>
  <div class="page-box">
    <div class="page-top">
      <div class="page-map" v-loading="loading">
        <Amap
          ref="amapRef"
          :marker-list="markerList"
          @marker-click="handleMarkerClick"
          @refresh="handleRefresh"
        />
      </div>
      <div class="page-search-box">
        <div class="page-search-item-box">
          <div class="page-search-item">
            <div class="page-search-item-label">门店名称</div>
            <div class="page-search-item-input">
              <el-input
                v-model="queryParam.storeName"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">开通状态</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.vip"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.vip"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">追溯体系</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.auth"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.auth"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">入驻情况</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.joinEnt"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.joinEnt"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">管理员姓名</div>
            <div class="page-search-item-input">
              <el-input
                v-model="queryParam.adminName"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">药师情况</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.pharJoinEnt"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.pharJoinEnt"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">远程审方</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.remoteAudit"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.remoteAudit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">经营状态</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.businessState"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.businessState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">经营分类</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.storeClass"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.storeClass"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="page-search-item">
            <div class="page-search-item-label">风险等级</div>
            <div class="page-search-item-input">
              <el-select
                v-model="queryParam.riskLevel"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.riskLevel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div class="page-search-button">
          <el-button type="primary" size="mini" @click="handleSearch"
            >查询</el-button
          >
          <el-button plain size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="table-box">
      <div class="table-d">
        <el-table
          ref="workTableRef"
          :data="tableList"
          stripe
          :header-cell-style="{
            background: '#F0F3F7',
            color: '#2a354e',
            fontWeight: 400,
          }"
          height="400"
          highlight-current-row
          :row-key="'id'"
          @row-click="handleRowClick"
          v-loading="loading"
          size="mini"
        >
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div class="vip-box">
                <div class="vip-left">
                  <img
                    style="width: 16px; height: 16px; cursor: pointer"
                    src="@/assets/location/address-table.png"
                    alt=""
                    @click="handleLocation(scope.row)"
                  />
                </div>
                <div class="vip-right">
                  <div
                    :class="[
                      'vip-right-title',
                      { isClick: scope.row.isVip, gray: !scope.row.isVip },
                    ]"
                    @click="handleDetail(scope.row)"
                  >
                    机构主页
                  </div>
                  <div class="vip-right-content">
                    <img
                      v-if="scope.row.isVip"
                      style="width: 14px; height: 11px; margin-right: 8px"
                      src="@/assets/layout/vip.png"
                      alt=""
                    />
                    <img
                      v-else
                      style="width: 14px; height: 11px; margin-right: 8px"
                      src="@/assets/layout/vip-gray.png"
                      alt=""
                    />
                    <span
                      :class="[
                        'vip-right-content-status',
                        { gray: !scope.row.isVip ? 'gray' : '' },
                      ]"
                      >{{ scope.row.isVip ? "已开通" : "未开通" }}</span
                    >
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="enterpriseName" label="门店信息" width="250">
            <template slot-scope="scope">
              <div class="table-lable">
                {{ scope.row.enterpriseName }}
              </div>
              <div class="table-value">
                {{ scope.row.location }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="authStr"
            label="追溯体系"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-status',
                  {
                    red: scope.row.authStr === '未建立',
                    yellow: scope.row.authStr === '未授权',
                  },
                ]"
              >
                {{ scope.row.authStr }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="joinEnterprise"
            label="入驻情况"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-status',
                  {
                    red: scope.row.joinEnterprise === '未入驻',
                  },
                ]"
              >
                {{ scope.row.joinEnterprise }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="realName"
            label="管理员"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="pharJoin"
            label="药师情况"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-status',
                  {
                    red: scope.row.pharJoin === '未入驻',
                    yellow: scope.row.pharJoin === '部分入驻',
                  },
                ]"
              >
                {{ scope.row.pharJoin }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hasUnSignedStr"
            label="远程审方"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-status',
                  {
                    red: scope.row.hasUnSignedStr === '已离线',
                  },
                ]"
              >
                {{ scope.row.hasUnSignedStr }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="businessStatusStr"
            label="经营状态"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-status',
                  {
                    red:
                      scope.row.businessStatusStr === '已停业' ||
                      scope.row.businessStatusStr === '经营异常',
                  },
                ]"
              >
                {{ scope.row.businessStatusStr }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="storeClassStr"
            label="经营分类"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="riskLevel"
            label="风险等级"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-status',
                  {
                    red: scope.row.riskLevel === 'D级',
                    yellow: scope.row.riskLevel === 'C级',
                    blue: scope.row.riskLevel === 'B级',
                  },
                ]"
              >
                {{ scope.row.riskLevel }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-page">
        <div class="table-page-index">当前 {{ paging.index }} 页</div>
        <el-pagination
          :current-page="paging.index"
          :page-size="paging.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Amap from "@/components/Amap";

export default {
  name: "Page",
  components: { Amap },
  props: {},
  data() {
    return {
      queryParam: {
        province: "",
        city: "",
        county: "",
        storeName: "",
        vip: "",
        auth: "",
        joinEnt: "",
        adminName: "",
        pharJoinEnt: "",
        remoteAudit: "",
        businessState: "",
        storeClass: "",
        riskLevel: "",
      },
      filterData: {},
      paging: {
        index: 1,
        size: 100,
      },
      total: 0,
      markerList: [],
      tableList: [],
      selectedRow: null,
      loading: false,
    };
  },
  mounted() {
    this.pageFetchData();
  },
  methods: {
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleRefresh(callback) {
      this.queryParam.province = "";
      this.queryParam.city = "";
      this.queryParam.county = "";
      this.paging.index = 1;
      this.getList().then(() => {
        callback && callback();
      });
    },
    handleMarkerClick(value) {
      this.queryParam.province = value.province;
      this.queryParam.city = value.city;
      this.queryParam.county = value.county;
      this.paging.index = 1;
      this.getList();
    },
    handleDetail(row) {
      this.$emit("detail", row);
    },
    handleLocation(row) {
      const lng = parseFloat(row.map.lng);
      const lat = parseFloat(row.map.lat);
      if (isNaN(lng) || isNaN(lat) || lng <= 0 || lat <= 0) {
        return;
      }
      this.$refs.amapRef.showInfoWindowAndClear([lng, lat], row.map);
    },
    handleCurrentChange(page) {
      this.paging.index = page;
      this.getList();
    },
    handleSearch() {
      this.paging.index = 1;
      this.getList();
    },
    handleReset() {
      this.queryParam.storeName = "";
      this.queryParam.vip = "";
      this.queryParam.auth = "";
      this.queryParam.joinEnt = "";
      this.queryParam.adminName = "";
      this.queryParam.pharJoinEnt = "";
      this.queryParam.remoteAudit = "";
      this.queryParam.businessState = "";
      this.queryParam.storeClass = "";
      this.queryParam.riskLevel = "";
    },
    async getList() {
      this.loading = true;
      const { data: tableData, extended } =
        await this.$api.enterprise.GetMyStoreList({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = tableData.list;
      this.markerList = tableData.map;
      this.total = extended.paging.total;
      this.loading = false;
    },
    async pageFetchData() {
      this.loading = true;
      const { data } = await this.$api.enterprise.GetMyStoreListFilters();
      this.filterData = data;
      const { data: tableData, extended } =
        await this.$api.enterprise.GetMyStoreList({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = tableData.list;
      this.markerList = tableData.map;
      this.total = extended.paging.total;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
</style>
